// Material UI
import { Box } from "@mui/material";

// Libraries
import get from "lodash/get";

const getHelperTextContent = ({
  hasError,
  errorMsg,
  baseHelperText,
  shouldHideErrorText,
  showHelperTextWithError,
}) => {
  if (!hasError) return baseHelperText;
  if (shouldHideErrorText) return baseHelperText;
  if (!showHelperTextWithError || !baseHelperText) return errorMsg;

  return (
    <>
      {errorMsg}
      <br />
      {baseHelperText}
    </>
  );
};

export const getHelperTextWithAction = ({
  helperTextContent,
  helperTextAction,
}) => {
  if (!helperTextAction) return helperTextContent;

  return (
    <Box
      sx={{ display: "flex", alignItems: "flex-start", gap: 1, width: "100%" }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>{helperTextContent}</Box>
      <Box sx={{ flexShrink: 0 }}>{helperTextAction}</Box>
    </Box>
  );
};

export const getFormikHelperTextState = ({
  formik,
  name,
  baseHelperText,
  hideErrorText,
  showHelperTextWithError,
}) => {
  const touched = get(formik.touched, name);
  const rawError = get(formik.errors, name);
  const errorMsg =
    rawError === 1 || rawError == null ? undefined : String(rawError);
  const hasError = Boolean(touched && errorMsg);
  const helperTextContent = getHelperTextContent({
    hasError,
    errorMsg,
    baseHelperText,
    shouldHideErrorText: Boolean(hideErrorText),
    showHelperTextWithError,
  });

  return {
    touched,
    errorMsg,
    hasError,
    helperTextContent,
  };
};
